const Style = (theme) => ({
  search__bar: {
    // display: 'flex',
    // alignItems: 'center',
    margin: '0 1.5rem 0 1.5rem',
    [theme.breakpoints.between(960, 1130)]: {
      margin: '0 1.5rem 0 1rem',
    },
  },
  search__btn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    borderRadius: '200px',
    background: 'rgba(109, 125, 139, 0.15)',
    color: 'rgba(109, 125, 139)',
    width: '185px',
    border: '1px solid #29264A',
    [theme.breakpoints.between(960, 1130)]: {
      width: '138px',
      fontSize: '12px',
      '& svg': {
        height: ' 17px',
        width: ' 17px',
      },
    },
  },
  vehicle__text: {
    fontSize: '15px',
    fontWeight: '500',
    padding: '0 1rem',
    color: '#000000',
    width: 'calc(100% - 185px)',
  },

  dropdown__main: {
    position: 'absolute',
    top: '4.9rem',
    width: '35rem',
    borderRadius: '15px',
    background: '#fff',
    boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.04)',
  },
});
export default Style;
